import { Grid, styled, TextField } from '@mui/material'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
const TextFieldStyled = styled(TextField)(() => ({
  '& .MuiInputLabel-root': {
    color: '#041C3F',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '1px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '1px',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '1px',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '1px',
  },
}));
const InputTextFieldGrid = ({
  xs,
  sx,
  name,
  control,
  required,
  label,
  pattern,
  inputType,
  step,
  disabled = false,
  multiline,
  placeholder,
  size = "small",
  rules = {},
  inputProps,
  InputProps,
  onTextChange = () => { },
  onFocus = () => { },
  defaultValue = "",
  onClick = () => { },
  render = (value) => value
}) => {
  const [focused, setFocused] = useState(false)
  return (
    <Grid
      item
      xs={xs}
      alignContent="center"
      justifyContent={"center"}
      style={{ width: '100%' }}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={!disabled && {
          ...rules,
          required
        }}
        render={({
          field: { value, onChange },
          fieldState: { error },
        }) => (
          <TextFieldStyled
            id={name}
            label={label}
            fullWidth
            required={!!required}
            pattern={pattern}
            size={size}
            value={focused ? value : render(value)}
            onClick={onClick}
            onChange={(e) => {
              onChange(e);
              onTextChange(e.target.value.trim());
            }}
            onBlur={(e) => {
              setFocused(false);
              if (value !== e.target.value.trim())
                onChange(e.target.value.trim());
            }}
            onFocus={() => {
              setFocused(true);
              onFocus()
            }}
            error={!!error}
            helperText={error && <span> {error.message}</span>}
            type={inputType}
            step={step}
            disabled={disabled}
            multiline={multiline}
            placeholder={placeholder}
            sx={sx}
            onWheel={e => {
              e.preventDefault()
              e.target.blur();
            }}
            inputProps={inputProps}
            InputProps={InputProps}
            InputLabelProps={['date', 'time', 'datetime-local'].includes(inputType) ? {
              shrink: true,
            } : {}}
          />
        )}
      />
    </Grid>
  )
}

export default InputTextFieldGrid